import { INTENT_TYPE } from '../../constants';
import { type ConvergenceRule } from '../types';

/**
 * `S-DEFAULT` (priority 850) — the terminal catch-all.
 *
 * Always matches, so every input ends with a pattern and telemetry never has to
 * represent "no decision".
 *
 * This row also absorbs the design's `R-SLM` residual row (priority 860). The two were
 * indistinguishable here: residual input is *defined* as whatever the deterministic
 * rules did not settle, and with `S-EMPTY` taking zero word tokens and `S-SHORT` taking
 * one and two, everything that reaches the bottom of the catalog has three or more —
 * which is exactly `R-SLM`'s predicate. Both emitted FPS, both reported
 * `didMatch: false`, so keeping them apart meant two names for one set.
 *
 * `didMatch: false` is therefore the signal that this input is residual: the local rules
 * classified it without settling it, and `getInputIntentMultilayer` passes exactly that
 * traffic to the remote layer — the design's SLM — once it lands.
 */
export const defaultRule: ConvergenceRule = {
	type: INTENT_TYPE.FPS,
	// The design table spells this reason `NO_MATCH`. It means exactly what this
	// package's pre-existing `NO_PATTERN` already means, so there is one value
	// rather than two names for one condition.
	pattern: 'NO_PATTERN',
	matches: () => true,
};
